import { useEffect, useState } from 'react';
import { InputText, IconTrash } from '@ui/src';
import { EntityAliasesFormValues } from '../../hoc/types';
import { AliasEntityTypes } from './types';

import cn from './blacklist.module.css';

const AliasEntity = ({
  alias,
  setAliases,
  aliases,
  length,
  id,
}: AliasEntityTypes) => {
  const [values, setValues] = useState<EntityAliasesFormValues>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValues = { ...values };

    if (e.target.name === `aliasTypeDesc-${id}`) {
      nextValues.aliasTypeDesc = e.target.value;
    } else if (e.target.name === `englishDescription-${id}`) {
      nextValues.englishDescription = e.target.value;
    } else if (e.target.name === `name-${id}`) {
      nextValues.name = e.target.value;
    } else if (e.target.name === `firstName-${id}`) {
      nextValues.firstName = e.target.value;
    } else if (e.target.name === `lastName-${id}`) {
      nextValues.lastName = e.target.value;
    } else if (e.target.name === `middleName-${id}`) {
      nextValues.middleName = e.target.value;
    }

    setValues(nextValues as EntityAliasesFormValues);

    if (aliases) {
      const nextAliases = aliases?.map((item) => {
        let result = { ...item };

        if (result.id === alias?.id) {
          result = nextValues as EntityAliasesFormValues;
        }

        return result;
      });

      setAliases(nextAliases);
    }
  };

  useEffect(() => {
    if (alias) {
      setValues(alias);
    }
  }, [alias]);

  return (
    <div className={cn.entityWrapper}>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`aliasTypeDesc-${id}`}
          value={values?.aliasTypeDesc}
          placeholder="Enter type"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`name-${id}`}
          value={values?.name}
          placeholder="Enter name"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`englishDescription-${id}`}
          value={values?.englishDescription}
          placeholder="Enter script"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`firstName-${id}`}
          value={values?.firstName}
          placeholder="Enter first"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`lastName-${id}`}
          value={values?.lastName}
          placeholder="Enter last"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div
        className={`${cn.entityValue} ${cn.flex}`}
        style={{ width: `${100 / length}%` }}
      >
        <InputText
          name={`middleName-${id}`}
          value={values?.middleName}
          placeholder="Enter middle"
          onChange={onChange}
          className={cn.borderless}
        />
        <button
          type="button"
          className={cn.deleteEntityButton}
          onClick={() => {
            setAliases(
              aliases?.filter(
                (item) => item.id !== id,
              ) as EntityAliasesFormValues[],
            );
          }}
        >
          <IconTrash />
        </button>
      </div>
    </div>
  );
};

export default AliasEntity;
